import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block text-sm text-gray-900 mb-1"
}

import { computed } from 'vue';
import Multiselect from '@vueform/multiselect';


export default /*@__PURE__*/_defineComponent({
  __name: 'MultiselectInput',
  props: {
    modelValue: {
        default: null,
        required: true
    },
    mode: {
        type: String,
        default: 'single' // single | multiple | tags
    },
    error: {
        type: String,
        default: null,
    },
    searchable: {
        type: Boolean,
        default: false
    },
    id: {
        type: String,
    },
    name: {
        type: String,
    },
    label: {
        type: String,
    },
    placeholder: {
        type: String,
        default: 'Placeholder'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    closeOnSelect: {
        type: Boolean,
        default: true
    },
    options: {
        type: Object,
        default: () => ({
            1: 'Option 1',
            2: 'Option 2',
            3: 'Option 3'
        })
    }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit

const value = computed<object>({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(Multiselect), {
      mode: __props.mode,
      searchable: __props.searchable,
      placeholder: __props.placeholder,
      disabled: __props.disabled,
      options: __props.options,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change'))),
      onSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select'))),
      onClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clear'))),
      class: "frm-multiselect",
      id: __props.id,
      name: __props.name
    }, null, 8, ["mode", "searchable", "placeholder", "disabled", "options", "modelValue", "id", "name"]),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})